<template>
    <div>
        <app-new-breadcrumb :routesName="this.$t('rrflUrlName')"></app-new-breadcrumb>
        <div class="main">
            <div class="description">
                <div class="description-inner">
                <div class="description-text">
                    <h2>{{ $t("rrflTitle") }}</h2>
                    <!-- <p>{{ $t("aboutUsShortText") }}</p> -->
                </div>
                <div class="description-img">
                    <img src="../../../assets/Profesionalnost.jpg">
                </div>
                </div>
            </div>
            <div class="main-part">
                <div class="page-inner">
                <div class="big-card">
                    <p v-html="$t('rrflText')"></p>
                </div>
                <div class="big-card">
                    <div class="big-card-title">
                        <i class="fa fa-solid fa-desktop"></i>
                        <h3>{{ $t('rrflExtractRequest') }}</h3>
                    </div>
                    <a href="https://resources.fia.ba/file/CC1E0C77-3CC1-EF11-8B91-00155D1E1316.docx" target="_blank">
                        <div class="big-card-btn">{{ $t('requestForm') }}</div>
                    </a>
                </div>
                <div class="big-card">
                    <div class="big-card-title">
                        <i class="fa fa-solid fa-desktop"></i>
                        <h3>{{ $t('rrflConsentForm') }}</h3>
                    </div>
                    <a href="https://resources.fia.ba/file/F0BDEDF8-8163-EF11-8B90-00155D1E1316.docx" target="_blank">
                        <div class="big-card-btn">{{ $t('requestForm') }}</div>
                    </a>
                </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import Breadcrumb from "../../common/Breadcrumb.vue";

export default {
    components: {
        appNewBreadcrumb: Breadcrumb,
    },
}
</script>

<style scoped>
</style>